export default __webpack_public_path__ + "static/media/defi-code-2.8a5886dc.png";